import * as ActionTypes from './index';

export function getBrokerFirmsWithAgents(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS,
        payload: payload
    }
}

export function getBrokerFirmsWithAgentsSuccess(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS_SUCCESS,
        payload: payload
    }
}

export function getBrokerFirmsWithAgentsFailed(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS_FAILED,
        payload: payload
    }
}

export function getBrokerFirms(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS,
        payload: payload
    }
}

export function getBrokerFirmsSuccess(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_SUCCESS,
        payload: payload
    }
}

export function getBrokerFirmsFailed(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_FAILED,
        payload: payload
    }
}
export function getBrokerFirmsPostcodes(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_POSTCODES,
        payload: payload
    }
}

export function getBrokerFirmsPostcodesSuccess(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_POSTCODES_SUCCESS,
        payload: payload
    }
}

export function getBrokerFirmsPostcodesFailed(payload) {
    return {
        type: ActionTypes.GET_BROKER_FIRMS_POSTCODES_FAILED,
        payload: payload
    }
}

export function requestBrokerFirmsFiltered(payload){
	return {
		type: ActionTypes.REQUEST_BROKER_FIRMS_FILTERED,
		payload: payload
	}
}

export function receiveBrokerFirmsFiltered(payload){
	return {
		type: ActionTypes.RECEIVE_BROKER_FIRMS_FILTERED,
		payload: payload
	}
}
